<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToRate'
});
</script>
<template>
	<div v-dis.opacity="disabled" class="to-rate" :class="[`color-${color}`, { 'is-half': allowHalf, 'is-readonly': isReadonly }]" :style="setStyle" @mouseleave="handleMouseLeave">
		<div
			v-for="i in max"
			:key="i"
			class="to-rate-item"
			:class="{
				'is-on': i <= ivalue,
				'is-half-on': allowHalf && i - 0.5 <= ivalue && i > ivalue,
				'is-hover': !isReadonly && i <= hoverIndex && !hoverHalf
			}"
			@click="handleClick(i, $event)"
			@mousemove="allowHalf && !isReadonly ? handleHalfMove(i, $event) : undefined"
			@mouseenter="!isReadonly ? (hoverIndex = i) : undefined"
		>
			<span class="to-rate-item-star"></span>
		</div>
		<div v-if="showScore" class="to-rate-score">{{ displayValue }}</div>
	</div>
</template>

<script lang="ts" setup>
import { CSSProperties, computed, ref, watch } from 'vue'



const props = defineProps({
	modelValue: {
		type: Number,
		default: 0
	},
	max: {
		type: Number,
		default: 5
	},
	size: {
		type: Number,
		default: 2
	},
	readonly: Boolean,
	allowHalf: {
		type: Boolean,
		default: false
	},
	color: {
		type: String,
		default: 'primary'
	},
	showScore: {
		type: Boolean,
		default: false
	},
	clearable: {
		type: Boolean,
		default: false
	}
})

const emit = defineEmits(['update:modelValue', 'change'])

const ivalue = ref(props.modelValue)
const hoverIndex = ref(0)
const hoverHalf = ref(false)

const isReadonly = computed(() => props.readonly)
const disabled = computed(() => props.readonly)

const displayValue = computed(() => {
	if (!isReadonly.value && hoverIndex.value > 0) {
		return hoverHalf.value ? hoverIndex.value - 0.5 : hoverIndex.value
	}
	return ivalue.value
})

const setStyle = computed(() => {
	const obj: CSSProperties = {}
	if (props.size) {
		obj['--size'] = props.size + 'em'
	}
	return obj
})

watch(
	() => props.modelValue,
	val => {
		ivalue.value = val
	},
	{ immediate: true }
)

function handleClick(i: number, event: MouseEvent) {
	if (isReadonly.value) return
	let value: number = i
	if (props.allowHalf) {
		const rect = (event.currentTarget as HTMLElement).getBoundingClientRect()
		const x = event.clientX - rect.left
		value = x < rect.width / 2 ? i - 0.5 : i
	}
	if (props.clearable && ivalue.value === value) {
		value = 0
	}
	ivalue.value = value
	emit('update:modelValue', value)
	emit('change', value)
}

function handleHalfMove(i: number, event: MouseEvent) {
	const rect = (event.currentTarget as HTMLElement).getBoundingClientRect()
	const x = event.clientX - rect.left
	hoverIndex.value = i
	hoverHalf.value = x < rect.width / 2
}

function handleMouseLeave() {
	if (!isReadonly.value) {
		hoverIndex.value = 0
		hoverHalf.value = false
	}
}
</script>
